// JOBE-0106: PeopleLane — Owner / Created by / Watchers lane on the
// project header card. Reads `members` from JOBE-0102's BFF response.
//
// Copy is pinned by ADR-0023 D5/D9:
//   - "Watchers" — not "Collaborators"
//   - "Add watcher" — not "Loop in"
// "Add watcher" is rendered disabled in v1 (write surface is Phase 7).
// "Reassign owner →" opens the ReassignOwnerModal (Decision 4, v1).
//
// Per-principal display name resolution is a future improvement —
// v1 shows the principal URN's local part as the fallback chip label.

import React from 'react';

export const ADD_WATCHER_DISABLED_TOOLTIP = 'Coming soon';

function urnLocalPart(urn) {
  if (!urn || typeof urn !== 'string') return '';
  const last = urn.split(':').pop();
  return last || urn;
}

function PrincipalChip({ urn, label }) {
  if (!urn) {
    return <span className="people-lane-chip people-lane-chip-empty muted">—</span>;
  }
  return (
    <span className="people-lane-chip" title={urn}>
      <span className="people-lane-chip-label mono">{label || urnLocalPart(urn)}</span>
    </span>
  );
}

export function PeopleLane({ members, onReassign }) {
  const creator = members?.creator || null;
  const assignee = members?.assignee || null;
  const watchers = Array.isArray(members?.watchers) ? members.watchers : [];

  return (
    <div className="project-people-lane">
      <h3 className="lane-title">People</h3>
      <div className="lane-row">
        <span className="lane-row-label">Owner</span>
        <PrincipalChip urn={assignee} />
        <button
          type="button"
          className="people-lane-reassign-link link-button"
          onClick={onReassign}
          data-testid="reassign-owner-link"
        >
          Reassign owner →
        </button>
      </div>
      <div className="lane-row">
        <span className="lane-row-label">Created by</span>
        <PrincipalChip urn={creator} />
      </div>
      <div className="lane-row">
        <span className="lane-row-label">Watchers</span>
        {watchers.length === 0 ? (
          <span className="muted people-lane-empty">no watchers</span>
        ) : (
          <span className="people-lane-watchers">
            {watchers.map((urn) => (
              <PrincipalChip key={urn} urn={urn} />
            ))}
          </span>
        )}
        <button
          type="button"
          className="people-lane-add-watcher"
          disabled
          title={ADD_WATCHER_DISABLED_TOOLTIP}
          data-testid="add-watcher-disabled"
        >
          Add watcher
        </button>
      </div>
    </div>
  );
}
